/* eslint-disable camelcase */
import { Box, Button } from '@mui/material'
import cx from 'classnames'

import CustomCheckbox from '../../CustomCheckbox'
import Spinner from '../../Spinner'

import { usePageTargeting } from './hooks/usePageTargeting'

import useGlobalStyles from '../style'
import useStyles from './style'

const Rank = ({ productData, setFooterHeight }) => {
  const {
    targetingType_SEARCH,
    targetingType_CATEGORY,
    targetingType_PDP,
    targetingType_PRODUCT,
    isPDPEnable,
    isProductEnable,
    isDataFetching,
    isDataUpdating,
    onUpdate,
    saveChanges,
    isChangesExist,
    showErrorMsg,
    footerRef,
  } = usePageTargeting({
    productData,
    setFooterHeight,
  })
  const globalClasses = useGlobalStyles()
  const classes = useStyles()

  return (
    <>
      <Box className={cx(globalClasses.wrapper_body, classes.body)}>
        <Box className={classes.table}>
          <Box className={classes.table__header}>
            <Box className={classes.table__row}>
              <Box className={classes.th}>Type</Box>
              <Box className={classes.th}>Active</Box>
            </Box>
          </Box>
          <Box className={classes.table__body}>
            {!isDataFetching && !isDataUpdating && (
              <>
                <Box className={classes.table__row}>
                  <Box className={classes.td}>Search</Box>
                  <Box className={classes.td}>
                    <CustomCheckbox
                      value={targetingType_SEARCH}
                      onChange={(v) => {
                        onUpdate({
                          targetingType_SEARCH: v ? 1 : 0,
                        })
                      }}
                    />
                  </Box>
                </Box>
                <Box className={classes.table__row}>
                  <Box className={classes.td}>Category</Box>
                  <Box className={classes.td}>
                    <CustomCheckbox
                      value={targetingType_CATEGORY}
                      onChange={(v) => {
                        onUpdate({
                          targetingType_CATEGORY: v ? 1 : 0,
                        })
                      }}
                    />
                  </Box>
                </Box>
                {isPDPEnable && (
                  <Box className={classes.table__row}>
                    <Box className={classes.td}>PDP</Box>
                    <Box className={classes.td}>
                      <CustomCheckbox
                        value={targetingType_PDP}
                        onChange={(v) => {
                          onUpdate({
                            targetingType_PDP: v ? 1 : 0,
                          })
                        }}
                      />
                    </Box>
                  </Box>
                )}
                {isProductEnable && (
                  <Box className={classes.table__row}>
                    <Box className={classes.td}>Product</Box>
                    <Box className={classes.td}>
                      <CustomCheckbox
                        value={targetingType_PRODUCT}
                        onChange={(v) => {
                          onUpdate({
                            targetingType_PRODUCT: v ? 1 : 0,
                          })
                        }}
                      />
                    </Box>
                  </Box>
                )}
              </>
            )}
            {(isDataFetching || isDataUpdating) && <Spinner />}
            {!isDataFetching && !isDataUpdating && showErrorMsg && (
              <div className={classes.error_message}>
                Please select at least one page targeting type. If you want to completely deactivate advertising for the
                product, please deactivate the product in the product cockpit
              </div>
            )}
          </Box>
        </Box>
      </Box>
      <Box className={cx(globalClasses.wrapper_footer, classes.footer)} ref={footerRef}>
        <Box className={classes.footer__controls}>
          <Button
            variant="contained"
            color="secondary"
            disabled={isDataUpdating || isDataFetching || !isChangesExist || showErrorMsg}
            className={globalClasses.save_btn}
            onClick={saveChanges}
          >
            Save changes
          </Button>
        </Box>
      </Box>
    </>
  )
}

export default Rank
